function getOrInvoke(maybeFn) {
  if (typeof maybeFn === 'function') {
    return maybeFn();
  } else {
    return maybeFn;
  }
}

export { getOrInvoke as g };
